import styled from "styled-components";
import { palette, size } from "styled-theme";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 0 5px;

  .please-call-text {
    text-align: center;
    color: ${palette("grayscale", 1)};
  }

  .sms-title {
    margin: 15px 0;
  }

  .animated-gif-esign {
    width: 100px;
    margin: 45px 0;
  }

  .validation-message {
    width: max-content;
    top: 47px;
    margin-top: 5px;
  }

  .input-group {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin: 45px 0;
  }

  .esign-button {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: auto;
    border-radius: ${size("borderRadius")};
    color: ${palette("button.default", 1)};
    background-color: ${palette("button.default", 0)};
    padding: 15px 25px;

    &:hover {
      background-color: ${palette("button.default", 2)};
    }

    &.disabled {
      background-color: ${palette("grayscale", 1)};

      :hover {
        background-color: ${palette("grayscale", 1)};
      }
    }
  }

  .sms-error {
    font-size: 13px;
    color: red;
    margin-top: 8px;
  }
`;

export default Wrapper;
